import useMediaQuery from "./useMediaQuery.ts";

export default function useIsMediaLessThan(px: number) {
  return useMediaQuery(`(max-width: ${px - 1}px)`);
}
